import { useTranslation } from 'react-i18next';

export const useCompletedMessage = (
    isCash: boolean,
    isOffline: boolean,
    isFRMinor: boolean
): string => {
    const { t } = useTranslation();
    const offlineMessage = isFRMinor
        ? t('epic.esport.stepComplete.body.minor.offline')
        : t('epic.esport.stepComplete.body.adult.offline');

    if (isCash) {
        return isOffline ? offlineMessage : t('epic.esport.stepComplete.body.hw');
    }
    return t('epic.esport.stepComplete.body.pg');
};
